<template>
  <div id="CustomerReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Customer Report</div>
            <div class="web-action-btn btn-groups text-right">
                <!-- Button for Clear Cache
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'customerReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'customerReport'" :position="'top'">
              </custom-pagination>
              <vue-good-table
                mode="remote"
                title="Customer Report"
                ref="customerReportTbl"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-select-all="onSelectAll"
                @on-selected-rows-change="selectionChanged"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :paginationOptions="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    dropdownAllowAll: false,
                    setCurrentPage:listCurrentPage,
                    perPageDropdown:dropDownPerPage,
                }"
                :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                }"
                :search-options="{
                enabled: false,
                }"

                >
              </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./../event-bus";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

let msgServer;
export default {
  name: "CustomerReport",
  metaInfo() {
            return {title: "Customer Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    batchProcess:0,
    batchNum:"",
    cantAccessPage:"",
    loading: false,

    permissions:[],
    rows: [],
    totalRecords: 0,
    action: '',
    userColumns:[],
    columns: [
                {
                    label: "Customer Company",
                    field: "company_code",
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "company", // placeholder for filter input
                      filterValue: "", // initial populated value for this filter
                      filterDropdownItems : ['000', '001', '002'], //dropdown (with selected values) instead of text input
                      trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Customer Number",
                    field: "customer_number",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: "Customer Suffix",
                    field: "customer_suffix",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Customer Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Address Line 1',
                    field: 'address_line_1',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Address Line 2',
                    field: 'address_line_2',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Address Line 3',
                    field: 'address_line_3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'City',
                    field: 'city',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'State',
                    field: 'state',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Country',
                    field: 'country',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable: false
                },
                {
                    label: 'Postal Code',
                    field: 'postal_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Phone',
                    field: 'work_phone',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Email',
                    field: 'email',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Customer Type',
                    field: 'type',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Pmt Terms',
                    field: 'term',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Finance Charge Code',
                    field: 'fin_charge_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Tax Auth Name',
                    field: 'tax_auth',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Tax Exempt Number',
                    field: 'tax_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: "Facility",
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                },
                {
                    label: 'Sales Rep',
                    field: 'sale_rep',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"option",
                },
                {
                    label: 'Hold Code',
                    field: 'hold_code',
                    hidden:false,
                    filterable: false,
                    fpFieldType:"text",
                    sortable:false,
                },
                {
                    label: 'Open Date',
                    field: 'open_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Credit Limit',
                    field: 'credit_limit',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    type:'number',
                },
                {
                    label: 'Available Credit',
                    field: 'avail_credit',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    type:'number',
                    sortable:false,
                },
                {
                    label: 'Unapplied Cash',
                    field: 'unapplied_cash',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    type:'number',
                    sortable:false,
                },
                {
                    label: 'Average Days To Pay',
                    field: 'avg_pay',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    type:'number',
                    // sortable:false,
                },
                {
                    label: 'Credit Manager',
                    field: 'credit_manager',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"option",
                },
                {
                    label: 'Active Flag',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Active', 'Inactive'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contacts',
                    field: 'contact',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Tax Exemptions',
                    field: 'tax_exemption',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Fax Number',
                    field: 'fax',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Receivable',
                    field: 'receivable',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    type:'number',
                    sortable:false,
                },


                 {
                    label: 'Last Invoice Date',
                    field: 'inv_date',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'PO Required',
                    field: 'po_req',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "PO Required", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Statment Print',
                    field: 'stmt_prnt',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Statement Print", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Maintenance Limit',
                    field: 'main_limit',
                    fpFieldType:"integer",
                    type:'number',
                    filterable: true,
                    hidden:false,
                    // sortable:false,
                },
                {
                    label: 'Hold Flag',
                    field: 'hold_flag',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Customer Class',
                    field: 'cust_class',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Fuel Terms Override',
                    field: 'fuel_term_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Fuel PO',
                    field: 'fuel_po',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'SalesRep Name',
                    field: 'sale_rep_name',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                },
                {
                    label: 'STD Industry Code',
                    field: 'std_ind_code',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Customer Group',
                    field: 'cust_grp',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Date Added',
                    field: 'created_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'User Added',
                    field: 'created_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Order Type',
                    field: 'order_type',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Payment Type',
                    field: 'pay_type',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Priority Code',
                    field: 'prior_code',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Alternate Reference',
                    field: 'alt_ref',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Statement Cycle Code',
                    field: 'stmt_day',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Statement Cycle Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['ACH', 'Monthly', 'Weekly'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Alternate EXT Number',
                    field: 'alt_ext_no',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false,
                },

            ],

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'customer_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  created: function() {
        this.serverParams.stopRequest = true;
    },
  methods:{
    cancelAll: function (cancelAll) {
        this.$refs.customerReportTbl.unselectAllInternal();
      },

    selectionChanged(param) {
        var self = this;
        self.serverParams.selectedAll = false;
        if(param.selectedRows.length == 100) {
          EventBus.$emit('clear-selection', false);
        } else {
          EventBus.$emit('clear-all-flags', false);
        }
        return;
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['customerReportTbl'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['customerReportTbl'].selectedRows[i].id)
      }
      var filterAll = self.serverParams.columnFilters;
      if ( self.action == "export" ) {
          filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }

      $.ajax({
        url: process.env.ROOT_API + "/customer-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: self.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {


            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'customer-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/CustomerReport.vue